import { INotification } from '../types/notification'
import { useAppStateContext } from './app-state'
import { ReducerActionsTypes } from '../types/app-state'
import { useCallback } from 'react'

export const useNotification = (): ((notification: INotification) => void) => {
  const [_, dispatch] = useAppStateContext()

  const onNotificaton = useCallback(
    (notification: INotification): void => {
      dispatch({
        type: ReducerActionsTypes.SET_NOTIFICATION,
        value: notification,
      })
    },
    [dispatch]
  )

  return onNotificaton
}
